import { styled } from '@linaria/react';

import { fonts, layout, primitives, radius, semantic, space } from '../../theme/tokens';

export const ContentColumn = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: 0;
`;

export const FormArea = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 0;
`;

export const FormPanel = styled.div`
  --voyager-signin-title-gap: ${space['space-600']};
  --voyager-signin-header-gap: ${space['space-600']};
  --voyager-signin-form-gap: ${space['space-600']};
  --voyager-signin-heading-size: ${fonts.size['2xl']};
  --voyager-signin-heading-weight: ${fonts.weight.normal};
  --voyager-signin-heading-tracking: -0.5px;
  --voyager-signin-subtitle-size: ${fonts.size.base};
  display: flex;
  flex-direction: column;
  gap: ${space['space-400']};
  width: 100%;

  @media (min-width: ${layout.desktopBreakpoint}) {
    --voyager-signin-heading-size: ${fonts.size['3xl']};
  }

  & button[type='submit'] {
    height: 56px;
    border-radius: ${radius('button', 'radius-full')};
    font-size: ${fonts.size.base};
  }

  & input:not([type='checkbox']) {
    height: 72px;
    border-radius: ${radius('input', 'radius-md')};
    font-size: ${fonts.size.base};
    padding: 0 ${layout.horizontalPadding};
  }
`;

export const SuccessMessage = styled.p`
  font-family: ${fonts.body};
  font-size: ${fonts.size.md};
  color: ${semantic.text.primary};
  text-align: center;
  line-height: ${primitives.typography.lineHeight.loose};
  margin: 0;
  width: 100%;
`;
